module.exports = __webpack_public_path__ + "static/logo-098947afd20b1d6907ec72f9eeed5538.png";